"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VatValidationStatus = exports.ValidationStatus = exports.ValidationErrorSeverity = exports.TransportType = exports.TransportMode = exports.SwivelStatus = exports.SwivelNature = exports.SanctionLogType = exports.PurchaserCode = exports.ProviderMetaDataEntityStatus = exports.PickupDeliveryLocationValidationType = exports.PickupDeliveryLocationType = exports.PickupDeliveryLocationStatus = exports.orderBy = exports.PickupDeliveryLocationDeleteReason = exports.PickupDeliveryLocationDeactivationReason = exports.PaymentMethodCode = exports.PartnerType = exports.PartnerPaymentTerm = exports.OperativeRole = exports.LegalEntityType = exports.LegalEntityStatus = exports.LegalEntityRoleStatus = exports.LegalEntityRole = exports.LegalEntityRegion = exports.FinanceRiskReason = exports.FinanceComplianceLogType = exports.CustomerType = exports.CustomerFeature = exports.CustomerDeactivationReason = exports.CurrencyCode = exports.CoordinatePrecision = exports.ContactPurposeServiceType = exports.ContactPurposeServiceFunction = exports.ComplianceStatus = exports.BulkScreenRequestType = exports.BcSyncStatus = exports.BankAccountStatus = exports.BankAccountDeletePurpose = exports.AssessmentType = exports.AssessmentClassification = exports.AirPartnerType = exports.AirPartnerService = exports.AdviceShippingType = exports.AddressSource = void 0;
var AddressSource;
(function (AddressSource) {
    AddressSource["AUTOCOMPLETE"] = "autocomplete";
    AddressSource["MANUAL"] = "manual";
})(AddressSource || (exports.AddressSource = AddressSource = {}));
var AdviceShippingType;
(function (AdviceShippingType) {
    AdviceShippingType["EMAIL"] = "EMAIL";
    AdviceShippingType["FAX"] = "FAX";
    AdviceShippingType["LETTER"] = "LETTER";
})(AdviceShippingType || (exports.AdviceShippingType = AdviceShippingType = {}));
var AirPartnerService;
(function (AirPartnerService) {
    AirPartnerService["MAIN_CARRIAGE"] = "MAIN_CARRIAGE";
    AirPartnerService["CARRIAGE"] = "CARRIAGE";
    AirPartnerService["CUSTOMS"] = "CUSTOMS";
    AirPartnerService["WAREHOUSING"] = "WAREHOUSING";
    AirPartnerService["GROUND_HANDLING"] = "GROUND_HANDLING";
    AirPartnerService["OTHER"] = "OTHER";
})(AirPartnerService || (exports.AirPartnerService = AirPartnerService = {}));
var AirPartnerType;
(function (AirPartnerType) {
    AirPartnerType["AGENT"] = "AGENT";
    AirPartnerType["CARRIER_AIRLINE"] = "CARRIER_AIRLINE";
    AirPartnerType["TRUCKING_PARTNER"] = "TRUCKING_PARTNER";
    AirPartnerType["PACKING_COMPANY"] = "PACKING_COMPANY";
    AirPartnerType["CUSTOMS_PARTNER"] = "CUSTOMS_PARTNER";
    AirPartnerType["GROUND_HANDLER"] = "GROUND_HANDLER";
    AirPartnerType["GEO_PARTNER"] = "GEO_PARTNER";
    AirPartnerType["CO_MASTERLOADER"] = "CO_MASTERLOADER";
    AirPartnerType["OTHER"] = "OTHER";
})(AirPartnerType || (exports.AirPartnerType = AirPartnerType = {}));
var AssessmentClassification;
(function (AssessmentClassification) {
    AssessmentClassification["TRUE_POSITIVE"] = "true-positive";
    AssessmentClassification["FALSE_POSITIVE"] = "false-positive";
})(AssessmentClassification || (exports.AssessmentClassification = AssessmentClassification = {}));
var AssessmentType;
(function (AssessmentType) {
    AssessmentType["ENTITY"] = "entity";
    AssessmentType["INDIVIDUAL"] = "individual";
    AssessmentType["VESSEL"] = "vessel";
    AssessmentType["AIRCRAFT"] = "aircraft";
    AssessmentType["LOCATION"] = "location";
})(AssessmentType || (exports.AssessmentType = AssessmentType = {}));
var BankAccountDeletePurpose;
(function (BankAccountDeletePurpose) {
    BankAccountDeletePurpose["CUSTOMER"] = "customer";
    BankAccountDeletePurpose["PARTNER"] = "partner";
})(BankAccountDeletePurpose || (exports.BankAccountDeletePurpose = BankAccountDeletePurpose = {}));
var BankAccountStatus;
(function (BankAccountStatus) {
    BankAccountStatus["APPROVED"] = "APPROVED";
    BankAccountStatus["PENDING"] = "PENDING";
})(BankAccountStatus || (exports.BankAccountStatus = BankAccountStatus = {}));
var BcSyncStatus;
(function (BcSyncStatus) {
    BcSyncStatus["FAILED"] = "FAILED";
    BcSyncStatus["SUCCESS"] = "SUCCESS";
    BcSyncStatus["PENDING"] = "PENDING";
    BcSyncStatus["SKIPPED"] = "SKIPPED";
})(BcSyncStatus || (exports.BcSyncStatus = BcSyncStatus = {}));
var BulkScreenRequestType;
(function (BulkScreenRequestType) {
    BulkScreenRequestType["LEGAL_ENTITIES"] = "legal-entities";
    BulkScreenRequestType["SWIVEL_PARTNERS"] = "swivel-partners";
    BulkScreenRequestType["PARTNER_LEGAL_ENTITIES"] = "partner-legal-entities";
    BulkScreenRequestType["ALL"] = "all";
})(BulkScreenRequestType || (exports.BulkScreenRequestType = BulkScreenRequestType = {}));
var ComplianceStatus;
(function (ComplianceStatus) {
    ComplianceStatus["PROCESSING"] = "PROCESSING";
    ComplianceStatus["PENDING"] = "PENDING";
    ComplianceStatus["VERIFIED"] = "VERIFIED";
    ComplianceStatus["FAILED"] = "FAILED";
})(ComplianceStatus || (exports.ComplianceStatus = ComplianceStatus = {}));
var ContactPurposeServiceFunction;
(function (ContactPurposeServiceFunction) {
    ContactPurposeServiceFunction["EQUIPMENT_RELEASE_POD"] = "equipmentReleasePOD";
    ContactPurposeServiceFunction["EQUIPMENT_REQUEST"] = "equipmentRequest";
    ContactPurposeServiceFunction["CARRIER_BOOKING_REQUEST"] = "carrierBookingRequest";
    ContactPurposeServiceFunction["CUSTOMER_SERVICE"] = "customerService";
    ContactPurposeServiceFunction["DOCUMENTATION"] = "documentation";
    ContactPurposeServiceFunction["CONTAINER_REUSE"] = "containerReuse";
    ContactPurposeServiceFunction["CONTAINER_REPAIRS"] = "containerRepairs";
    ContactPurposeServiceFunction["TRANSPORT_ORDER"] = "transportOrder";
})(ContactPurposeServiceFunction || (exports.ContactPurposeServiceFunction = ContactPurposeServiceFunction = {}));
var ContactPurposeServiceType;
(function (ContactPurposeServiceType) {
    ContactPurposeServiceType["SEA_FREIGHT_FCL"] = "seaFreightFCL";
    ContactPurposeServiceType["TRANSPORT_FCL"] = "transportFCL";
})(ContactPurposeServiceType || (exports.ContactPurposeServiceType = ContactPurposeServiceType = {}));
var CoordinatePrecision;
(function (CoordinatePrecision) {
    CoordinatePrecision["ROUTE1"] = "route1";
    CoordinatePrecision["ROUTE2"] = "route2";
    CoordinatePrecision["LOCALITY1"] = "locality1";
    CoordinatePrecision["LOCALITY2"] = "locality2";
    CoordinatePrecision["REGION1"] = "region1";
    CoordinatePrecision["REGION2"] = "region2";
    CoordinatePrecision["REGION3"] = "region3";
    CoordinatePrecision["REGION4"] = "region4";
    CoordinatePrecision["POSTAL_CODE"] = "postalCode";
    CoordinatePrecision["COUNTRY_CODE"] = "countryCode";
})(CoordinatePrecision || (exports.CoordinatePrecision = CoordinatePrecision = {}));
var CurrencyCode;
(function (CurrencyCode) {
    CurrencyCode["_"] = "%";
    CurrencyCode["AED"] = "AED";
    CurrencyCode["AFN"] = "AFN";
    CurrencyCode["AUD"] = "AUD";
    CurrencyCode["AZN"] = "AZN";
    CurrencyCode["BDT"] = "BDT";
    CurrencyCode["BGN"] = "BGN";
    CurrencyCode["BHD"] = "BHD";
    CurrencyCode["BND"] = "BND";
    CurrencyCode["BRL"] = "BRL";
    CurrencyCode["BTC"] = "BTC";
    CurrencyCode["CAD"] = "CAD";
    CurrencyCode["CHF"] = "CHF";
    CurrencyCode["CNY"] = "CNY";
    CurrencyCode["CRC"] = "CRC";
    CurrencyCode["CUP"] = "CUP";
    CurrencyCode["CYP"] = "CYP";
    CurrencyCode["CZK"] = "CZK";
    CurrencyCode["DKK"] = "DKK";
    CurrencyCode["DZD"] = "DZD";
    CurrencyCode["EEK"] = "EEK";
    CurrencyCode["EGP"] = "EGP";
    CurrencyCode["EUR"] = "EUR";
    CurrencyCode["FJD"] = "FJD";
    CurrencyCode["GBP"] = "GBP";
    CurrencyCode["GEL"] = "GEL";
    CurrencyCode["HKD"] = "HKD";
    CurrencyCode["HRK"] = "HRK";
    CurrencyCode["HUF"] = "HUF";
    CurrencyCode["IDR"] = "IDR";
    CurrencyCode["ILS"] = "ILS";
    CurrencyCode["INR"] = "INR";
    CurrencyCode["IQD"] = "IQD";
    CurrencyCode["IRR"] = "IRR";
    CurrencyCode["ISK"] = "ISK";
    CurrencyCode["JOD"] = "JOD";
    CurrencyCode["JPY"] = "JPY";
    CurrencyCode["KGS"] = "KGS";
    CurrencyCode["KHR"] = "KHR";
    CurrencyCode["KRW"] = "KRW";
    CurrencyCode["KWD"] = "KWD";
    CurrencyCode["LKR"] = "LKR";
    CurrencyCode["LTL"] = "LTL";
    CurrencyCode["LVL"] = "LVL";
    CurrencyCode["MAD"] = "MAD";
    CurrencyCode["MMK"] = "MMK";
    CurrencyCode["MNT"] = "MNT";
    CurrencyCode["MTL"] = "MTL";
    CurrencyCode["MXN"] = "MXN";
    CurrencyCode["MYR"] = "MYR";
    CurrencyCode["NAD"] = "NAD";
    CurrencyCode["NGN"] = "NGN";
    CurrencyCode["NOK"] = "NOK";
    CurrencyCode["NPR"] = "NPR";
    CurrencyCode["NZD"] = "NZD";
    CurrencyCode["OMR"] = "OMR";
    CurrencyCode["PGK"] = "PGK";
    CurrencyCode["PHP"] = "PHP";
    CurrencyCode["PKR"] = "PKR";
    CurrencyCode["PLN"] = "PLN";
    CurrencyCode["QAR"] = "QAR";
    CurrencyCode["ROL"] = "ROL";
    CurrencyCode["RON"] = "RON";
    CurrencyCode["RUB"] = "RUB";
    CurrencyCode["SAR"] = "SAR";
    CurrencyCode["SDG"] = "SDG";
    CurrencyCode["SEK"] = "SEK";
    CurrencyCode["SGD"] = "SGD";
    CurrencyCode["SIT"] = "SIT";
    CurrencyCode["SKK"] = "SKK";
    CurrencyCode["STD"] = "STD";
    CurrencyCode["THB"] = "THB";
    CurrencyCode["TRL"] = "TRL";
    CurrencyCode["TND"] = "TND";
    CurrencyCode["TRY"] = "TRY";
    CurrencyCode["TWD"] = "TWD";
    CurrencyCode["UAH"] = "UAH";
    CurrencyCode["USD"] = "USD";
    CurrencyCode["VND"] = "VND";
    CurrencyCode["XBT"] = "XBT";
    CurrencyCode["XPF"] = "XPF";
    CurrencyCode["ZAR"] = "ZAR";
})(CurrencyCode || (exports.CurrencyCode = CurrencyCode = {}));
var CustomerDeactivationReason;
(function (CustomerDeactivationReason) {
    CustomerDeactivationReason["FBA_SERVICE_STOP"] = "FBA_SERVICE_STOP";
})(CustomerDeactivationReason || (exports.CustomerDeactivationReason = CustomerDeactivationReason = {}));
var CustomerFeature;
(function (CustomerFeature) {
    CustomerFeature["SUPPLIER_BOOKING"] = "SUPPLIER_BOOKING";
    CustomerFeature["LANDED_COSTS"] = "LANDED_COSTS";
    CustomerFeature["NEW_SHIP_UI"] = "NEW_SHIP_UI";
    CustomerFeature["NPS_EMAIL"] = "NPS_EMAIL";
    CustomerFeature["PURCHASE_ORDER_MANAGEMENT"] = "PURCHASE_ORDER_MANAGEMENT";
    CustomerFeature["DISABLE_WELCOME_USER_EMAILS"] = "DISABLE_WELCOME_USER_EMAILS";
    CustomerFeature["DANGEROUS_GOODS_AUTO_QUOTE"] = "DANGEROUS_GOODS_AUTO_QUOTE";
    CustomerFeature["OFFSET_SERVICE"] = "OFFSET_SERVICE";
})(CustomerFeature || (exports.CustomerFeature = CustomerFeature = {}));
var CustomerType;
(function (CustomerType) {
    CustomerType["CONTROLLING_CUSTOMER"] = "controlling-customer";
    CustomerType["NON_CONTROLLING_CUSTOMER"] = "non-controlling-customer";
    CustomerType["PARTNER"] = "partner";
    CustomerType["INTERCOMPANY"] = "intercompany";
})(CustomerType || (exports.CustomerType = CustomerType = {}));
var FinanceComplianceLogType;
(function (FinanceComplianceLogType) {
    FinanceComplianceLogType["RISK"] = "RISK";
})(FinanceComplianceLogType || (exports.FinanceComplianceLogType = FinanceComplianceLogType = {}));
var FinanceRiskReason;
(function (FinanceRiskReason) {
    FinanceRiskReason["INSOLVENCY"] = "INSOLVENCY";
    FinanceRiskReason["LEGAL_ACTIONS"] = "LEGAL_ACTIONS";
    FinanceRiskReason["FINANCIAL_DETERIORATION"] = "FINANCIAL_DETERIORATION";
    FinanceRiskReason["HIGH_OVERDUE_SITUATION"] = "HIGH_OVERDUE_SITUATION";
})(FinanceRiskReason || (exports.FinanceRiskReason = FinanceRiskReason = {}));
var LegalEntityRegion;
(function (LegalEntityRegion) {
    LegalEntityRegion["EU"] = "EU";
    LegalEntityRegion["NON_EU"] = "NON_EU";
})(LegalEntityRegion || (exports.LegalEntityRegion = LegalEntityRegion = {}));
var LegalEntityRole;
(function (LegalEntityRole) {
    LegalEntityRole["CONSIGNEE"] = "consignee";
    LegalEntityRole["SHIPPER"] = "shipper";
    LegalEntityRole["INTERCOMPANY"] = "intercompany";
    LegalEntityRole["PARTNER"] = "partner";
})(LegalEntityRole || (exports.LegalEntityRole = LegalEntityRole = {}));
var LegalEntityRoleStatus;
(function (LegalEntityRoleStatus) {
    LegalEntityRoleStatus["ACTIVE"] = "active";
    LegalEntityRoleStatus["INACTIVE"] = "inactive";
})(LegalEntityRoleStatus || (exports.LegalEntityRoleStatus = LegalEntityRoleStatus = {}));
var LegalEntityStatus;
(function (LegalEntityStatus) {
    LegalEntityStatus["ACTIVE"] = "active";
    LegalEntityStatus["INACTIVE"] = "inactive";
})(LegalEntityStatus || (exports.LegalEntityStatus = LegalEntityStatus = {}));
var LegalEntityType;
(function (LegalEntityType) {
    LegalEntityType["CONSIGNEE"] = "consignee";
    LegalEntityType["SHIPPER"] = "shipper";
    LegalEntityType["INTERCOMPANY"] = "intercompany";
})(LegalEntityType || (exports.LegalEntityType = LegalEntityType = {}));
var OperativeRole;
(function (OperativeRole) {
    OperativeRole["OPS_MAIN_CONTACT"] = "OPS_MAIN_CONTACT";
    OperativeRole["PRIMARY_CONTACT"] = "PRIMARY_CONTACT";
    OperativeRole["BILLING_ACCOUNTING"] = "BILLING_ACCOUNTING";
    OperativeRole["OPS_CUSTOMS"] = "OPS_CUSTOMS";
    OperativeRole["OPS_ESCALATIONS"] = "OPS_ESCALATIONS";
    OperativeRole["OPS_WAREHOUSE"] = "OPS_WAREHOUSE";
    OperativeRole["PROCUREMENT"] = "PROCUREMENT";
    OperativeRole["SUPPLIER"] = "SUPPLIER";
    OperativeRole["SUSTAINABILITY_MANAGER"] = "SUSTAINABILITY_MANAGER";
    OperativeRole["LOGISTICS_OPS_CONTACT"] = "LOGISTICS_OPS_CONTACT";
    OperativeRole["LEGAL_CONTACT"] = "LEGAL_CONTACT";
    OperativeRole["ADVICE_SHIPPING_CONTACT"] = "ADVICE_SHIPPING_CONTACT";
    OperativeRole["DUNNING_CONTACT"] = "DUNNING_CONTACT";
})(OperativeRole || (exports.OperativeRole = OperativeRole = {}));
var PartnerPaymentTerm;
(function (PartnerPaymentTerm) {
    PartnerPaymentTerm["_0D"] = "0D";
    PartnerPaymentTerm["_1D"] = "1D";
    PartnerPaymentTerm["_2D"] = "2D";
    PartnerPaymentTerm["_3D"] = "3D";
    PartnerPaymentTerm["_4D"] = "4D";
    PartnerPaymentTerm["_5D"] = "5D";
    PartnerPaymentTerm["_6D"] = "6D";
    PartnerPaymentTerm["_7D"] = "7D";
    PartnerPaymentTerm["_8D"] = "8D";
    PartnerPaymentTerm["_9D"] = "9D";
    PartnerPaymentTerm["_10D"] = "10D";
    PartnerPaymentTerm["_11D"] = "11D";
    PartnerPaymentTerm["_12D"] = "12D";
    PartnerPaymentTerm["_13D"] = "13D";
    PartnerPaymentTerm["_14D"] = "14D";
    PartnerPaymentTerm["_15D"] = "15D";
    PartnerPaymentTerm["_16D"] = "16D";
    PartnerPaymentTerm["_17D"] = "17D";
    PartnerPaymentTerm["_18D"] = "18D";
    PartnerPaymentTerm["_19D"] = "19D";
    PartnerPaymentTerm["_20D"] = "20D";
    PartnerPaymentTerm["_21D"] = "21D";
    PartnerPaymentTerm["_22D"] = "22D";
    PartnerPaymentTerm["_23D"] = "23D";
    PartnerPaymentTerm["_24D"] = "24D";
    PartnerPaymentTerm["_25D"] = "25D";
    PartnerPaymentTerm["_26D"] = "26D";
    PartnerPaymentTerm["_27D"] = "27D";
    PartnerPaymentTerm["_28D"] = "28D";
    PartnerPaymentTerm["_29D"] = "29D";
    PartnerPaymentTerm["_30D"] = "30D";
    PartnerPaymentTerm["_31D"] = "31D";
    PartnerPaymentTerm["_32D"] = "32D";
    PartnerPaymentTerm["_33D"] = "33D";
    PartnerPaymentTerm["_34D"] = "34D";
    PartnerPaymentTerm["_35D"] = "35D";
    PartnerPaymentTerm["_36D"] = "36D";
    PartnerPaymentTerm["_37D"] = "37D";
    PartnerPaymentTerm["_38D"] = "38D";
    PartnerPaymentTerm["_39D"] = "39D";
    PartnerPaymentTerm["_40D"] = "40D";
    PartnerPaymentTerm["_41D"] = "41D";
    PartnerPaymentTerm["_42D"] = "42D";
    PartnerPaymentTerm["_43D"] = "43D";
    PartnerPaymentTerm["_44D"] = "44D";
    PartnerPaymentTerm["_45D"] = "45D";
    PartnerPaymentTerm["_46D"] = "46D";
    PartnerPaymentTerm["_47D"] = "47D";
    PartnerPaymentTerm["_48D"] = "48D";
    PartnerPaymentTerm["_49D"] = "49D";
    PartnerPaymentTerm["_50D"] = "50D";
    PartnerPaymentTerm["_51D"] = "51D";
    PartnerPaymentTerm["_52D"] = "52D";
    PartnerPaymentTerm["_53D"] = "53D";
    PartnerPaymentTerm["_54D"] = "54D";
    PartnerPaymentTerm["_55D"] = "55D";
    PartnerPaymentTerm["_56D"] = "56D";
    PartnerPaymentTerm["_57D"] = "57D";
    PartnerPaymentTerm["_58D"] = "58D";
    PartnerPaymentTerm["_59D"] = "59D";
    PartnerPaymentTerm["_60D"] = "60D";
    PartnerPaymentTerm["_61D"] = "61D";
    PartnerPaymentTerm["_62D"] = "62D";
    PartnerPaymentTerm["_63D"] = "63D";
    PartnerPaymentTerm["_64D"] = "64D";
    PartnerPaymentTerm["_65D"] = "65D";
    PartnerPaymentTerm["_66D"] = "66D";
    PartnerPaymentTerm["_67D"] = "67D";
    PartnerPaymentTerm["_68D"] = "68D";
    PartnerPaymentTerm["_69D"] = "69D";
    PartnerPaymentTerm["_70D"] = "70D";
    PartnerPaymentTerm["_71D"] = "71D";
    PartnerPaymentTerm["_72D"] = "72D";
    PartnerPaymentTerm["_73D"] = "73D";
    PartnerPaymentTerm["_74D"] = "74D";
    PartnerPaymentTerm["_75D"] = "75D";
    PartnerPaymentTerm["_76D"] = "76D";
    PartnerPaymentTerm["_77D"] = "77D";
    PartnerPaymentTerm["_78D"] = "78D";
    PartnerPaymentTerm["_79D"] = "79D";
    PartnerPaymentTerm["_80D"] = "80D";
    PartnerPaymentTerm["_81D"] = "81D";
    PartnerPaymentTerm["_82D"] = "82D";
    PartnerPaymentTerm["_83D"] = "83D";
    PartnerPaymentTerm["_84D"] = "84D";
    PartnerPaymentTerm["_85D"] = "85D";
    PartnerPaymentTerm["_86D"] = "86D";
    PartnerPaymentTerm["_87D"] = "87D";
    PartnerPaymentTerm["_88D"] = "88D";
    PartnerPaymentTerm["_89D"] = "89D";
    PartnerPaymentTerm["_90D"] = "90D";
    PartnerPaymentTerm["_10FM"] = "10FM";
    PartnerPaymentTerm["_15CM"] = "15CM";
    PartnerPaymentTerm["_15FM"] = "15FM";
    PartnerPaymentTerm["_20CM"] = "20CM";
    PartnerPaymentTerm["_20FM"] = "20FM";
    PartnerPaymentTerm["_23CM"] = "23CM";
    PartnerPaymentTerm["_25CM"] = "25CM";
    PartnerPaymentTerm["_25FM"] = "25FM";
    PartnerPaymentTerm["BI_W"] = "BI_W";
    PartnerPaymentTerm["CM"] = "CM";
    PartnerPaymentTerm["COD"] = "COD";
    PartnerPaymentTerm["D20"] = "D20";
    PartnerPaymentTerm["D5"] = "D5";
    PartnerPaymentTerm["EFM"] = "EFM";
})(PartnerPaymentTerm || (exports.PartnerPaymentTerm = PartnerPaymentTerm = {}));
var PartnerType;
(function (PartnerType) {
    PartnerType["SEA"] = "SEA";
    PartnerType["RAIL"] = "RAIL";
    PartnerType["AIR"] = "AIR";
    PartnerType["GEO_PARTNER"] = "GEO_PARTNER";
    PartnerType["INTERMODAL"] = "INTERMODAL";
    PartnerType["CUSTOMS"] = "CUSTOMS";
    PartnerType["OTHER"] = "OTHER";
})(PartnerType || (exports.PartnerType = PartnerType = {}));
var PaymentMethodCode;
(function (PaymentMethodCode) {
    PaymentMethodCode["BANK"] = "BANK";
    PaymentMethodCode["CASH"] = "CASH";
    PaymentMethodCode["CUSTOMS"] = "CUSTOMS";
    PaymentMethodCode["DTAZV_COGS"] = "DTAZV_COGS";
    PaymentMethodCode["DTAZV_CUST"] = "DTAZV_CUST";
    PaymentMethodCode["ISO_PMT"] = "ISO_PMT";
    PaymentMethodCode["SAN_EUR"] = "SAN_EUR";
    PaymentMethodCode["SAN_PLN"] = "SAN_PLN";
    PaymentMethodCode["SAN_USD"] = "SAN_USD";
    PaymentMethodCode["SEPA_COGS"] = "SEPA_COGS";
    PaymentMethodCode["SEPA_CUST"] = "SEPA_CUST";
    PaymentMethodCode["STANDING_ORDER"] = "STANDING_ORDER";
    PaymentMethodCode["WIRE"] = "WIRE";
})(PaymentMethodCode || (exports.PaymentMethodCode = PaymentMethodCode = {}));
var PickupDeliveryLocationDeactivationReason;
(function (PickupDeliveryLocationDeactivationReason) {
    PickupDeliveryLocationDeactivationReason["CUSTOMER_RELOCATION"] = "customerRelocation";
    PickupDeliveryLocationDeactivationReason["WAREHOUSE_RELOCATION"] = "warehouseRelocation";
    PickupDeliveryLocationDeactivationReason["TEMPORARY_ADDRESS"] = "temporaryAddress";
    PickupDeliveryLocationDeactivationReason["NO_WAREHOUSE_LOCATION_FOR_DELIVERY"] = "noWarehouseLocationForDelivery";
    PickupDeliveryLocationDeactivationReason["REGULATORY_OR_COMPLIANCE_RESTRICTIONS"] = "regulatoryOrComplianceRestrictions";
})(PickupDeliveryLocationDeactivationReason || (exports.PickupDeliveryLocationDeactivationReason = PickupDeliveryLocationDeactivationReason = {}));
var PickupDeliveryLocationDeleteReason;
(function (PickupDeliveryLocationDeleteReason) {
    PickupDeliveryLocationDeleteReason["DUPLICATE_ADDRESS"] = "duplicateAddress";
    PickupDeliveryLocationDeleteReason["INCORRECT_OR_INVALID_ADDRESS"] = "incorrectOrInvalidAddress";
    PickupDeliveryLocationDeleteReason["NO_WAREHOUSE_LOCATION_FOR_DELIVERY"] = "noWarehouseLocationForDelivery";
    PickupDeliveryLocationDeleteReason["REGULATORY_OR_COMPLIANCE_RESTRICTIONS"] = "regulatoryOrComplianceRestrictions";
})(PickupDeliveryLocationDeleteReason || (exports.PickupDeliveryLocationDeleteReason = PickupDeliveryLocationDeleteReason = {}));
var orderBy;
(function (orderBy) {
    orderBy["CREATED_AT"] = "createdAt";
    orderBy["LOCATION_NAME"] = "locationName";
    orderBy["SEARCH"] = "search";
})(orderBy || (exports.orderBy = orderBy = {}));
var PickupDeliveryLocationStatus;
(function (PickupDeliveryLocationStatus) {
    PickupDeliveryLocationStatus["ACTIVE"] = "active";
    PickupDeliveryLocationStatus["INACTIVE"] = "inactive";
})(PickupDeliveryLocationStatus || (exports.PickupDeliveryLocationStatus = PickupDeliveryLocationStatus = {}));
var PickupDeliveryLocationType;
(function (PickupDeliveryLocationType) {
    PickupDeliveryLocationType["PICKUP"] = "pickup";
    PickupDeliveryLocationType["DELIVERY"] = "delivery";
})(PickupDeliveryLocationType || (exports.PickupDeliveryLocationType = PickupDeliveryLocationType = {}));
var PickupDeliveryLocationValidationType;
(function (PickupDeliveryLocationValidationType) {
    PickupDeliveryLocationValidationType["MANUAL"] = "manual";
    PickupDeliveryLocationValidationType["VERIFIED"] = "verified";
})(PickupDeliveryLocationValidationType || (exports.PickupDeliveryLocationValidationType = PickupDeliveryLocationValidationType = {}));
var ProviderMetaDataEntityStatus;
(function (ProviderMetaDataEntityStatus) {
    ProviderMetaDataEntityStatus["ACTIVE"] = "ACTIVE";
    ProviderMetaDataEntityStatus["INACTIVE"] = "INACTIVE";
})(ProviderMetaDataEntityStatus || (exports.ProviderMetaDataEntityStatus = ProviderMetaDataEntityStatus = {}));
var PurchaserCode;
(function (PurchaserCode) {
    PurchaserCode["COGS"] = "COGS";
    PurchaserCode["CUSTOMS"] = "CUSTOMS";
    PurchaserCode["COGS_CUSTOMS"] = "COGS_CUSTOMS";
})(PurchaserCode || (exports.PurchaserCode = PurchaserCode = {}));
var SanctionLogType;
(function (SanctionLogType) {
    SanctionLogType["MANUAL"] = "manual";
    SanctionLogType["AUTOMATIC"] = "automatic";
})(SanctionLogType || (exports.SanctionLogType = SanctionLogType = {}));
var SwivelNature;
(function (SwivelNature) {
    SwivelNature["AERONAUTIC"] = "AERONAUTIC";
    SwivelNature["AGENT"] = "AGENT";
    SwivelNature["AGENTS_AGENT"] = "AGENTS_AGENT";
    SwivelNature["AIRLINE"] = "AIRLINE";
    SwivelNature["ARTWARE"] = "ARTWARE";
    SwivelNature["AUTOMOTIVE"] = "AUTOMOTIVE";
    SwivelNature["BABY_PRODUCTS"] = "BABY_PRODUCTS";
    SwivelNature["BIOTECHNOLOGY"] = "BIOTECHNOLOGY";
    SwivelNature["CARRIER"] = "CARRIER";
    SwivelNature["CHEMICALS"] = "CHEMICALS";
    SwivelNature["COLOADER"] = "COLOADER";
    SwivelNature["COLOADERS_AGENT"] = "COLOADERS_AGENT";
    SwivelNature["COMPUTER_PERIPHERALS"] = "COMPUTER_PERIPHERALS";
    SwivelNature["CONSTRUCTIONS"] = "CONSTRUCTIONS";
    SwivelNature["CUSTOMS"] = "CUSTOMS";
    SwivelNature["CUSTOMS_BROKER"] = "CUSTOMS_BROKER";
    SwivelNature["DG"] = "DG";
    SwivelNature["ELECTRONICS_ELECTRICAL_APPLIANCES"] = "ELECTRONICS_ELECTRICAL_APPLIANCES";
    SwivelNature["ENERGY"] = "ENERGY";
    SwivelNature["ENVIRONMENTAL_PROTECTION_EQUIPMENT_PRODUCT"] = "ENVIRONMENTAL_PROTECTION_EQUIPMENT_PRODUCT";
    SwivelNature["EXPORT_LICENSE"] = "EXPORT_LICENSE";
    SwivelNature["EYEWEAR_ACCESSORIES"] = "EYEWEAR_ACCESSORIES";
    SwivelNature["FACTORY"] = "FACTORY";
    SwivelNature["FAK"] = "FAK";
    SwivelNature["FOOD_BEVERAGE_TOBACCO"] = "FOOD_BEVERAGE_TOBACCO";
    SwivelNature["FOOTWEAR"] = "FOOTWEAR";
    SwivelNature["FORWARDER"] = "FORWARDER";
    SwivelNature["FREIGHT_CASHIER"] = "FREIGHT_CASHIER";
    SwivelNature["FURNITURE"] = "FURNITURE";
    SwivelNature["GIFTS_PREMIUMS"] = "GIFTS_PREMIUMS";
    SwivelNature["HANDBAGS_TRAVEL_GOODS"] = "HANDBAGS_TRAVEL_GOODS";
    SwivelNature["HEALTHCARE"] = "HEALTHCARE";
    SwivelNature["HOUSEHOLD_PERSONAL_PRODUCTS"] = "HOUSEHOLD_PERSONAL_PRODUCTS";
    SwivelNature["INDUSTRIALS"] = "INDUSTRIALS";
    SwivelNature["JEWELLERY"] = "JEWELLERY";
    SwivelNature["LEATHER"] = "LEATHER";
    SwivelNature["LIGHTING_PRODUCTS"] = "LIGHTING_PRODUCTS";
    SwivelNature["LOGISTICS_TRANSPORT_SERVICES"] = "LOGISTICS_TRANSPORT_SERVICES";
    SwivelNature["MECHANICAL_ENGINEERING"] = "MECHANICAL_ENGINEERING";
    SwivelNature["MEDICAL_SUPPLIES_MEDICINE"] = "MEDICAL_SUPPLIES_MEDICINE";
    SwivelNature["MINING_METALS_MINERALS"] = "MINING_METALS_MINERALS";
    SwivelNature["OCEAN_CARRIER"] = "OCEAN_CARRIER";
    SwivelNature["OTHERS"] = "OTHERS";
    SwivelNature["PACKAGING_PRODUCT_MATERIAL"] = "PACKAGING_PRODUCT_MATERIAL";
    SwivelNature["PET_PET_SUPPLIES"] = "PET_PET_SUPPLIES";
    SwivelNature["PHOTOGRAPHIC_OPTICAL_EQUIPMENT"] = "PHOTOGRAPHIC_OPTICAL_EQUIPMENT";
    SwivelNature["RETAIL"] = "RETAIL";
    SwivelNature["RUBBER_PRODUCTS"] = "RUBBER_PRODUCTS";
    SwivelNature["SPECIALISED_PRODUCTS"] = "SPECIALISED_PRODUCTS";
    SwivelNature["SPORTS_GOODS"] = "SPORTS_GOODS";
    SwivelNature["STATIONERY_OFFICE_EQUIPMENT"] = "STATIONERY_OFFICE_EQUIPMENT";
    SwivelNature["TELECOMMUNICATION"] = "TELECOMMUNICATION";
    SwivelNature["TEXTILES_CLOTHING"] = "TEXTILES_CLOTHING";
    SwivelNature["TOYS"] = "TOYS";
    SwivelNature["TRADING"] = "TRADING";
    SwivelNature["TRUCKER"] = "TRUCKER";
    SwivelNature["TRUCKING"] = "TRUCKING";
    SwivelNature["WAREHOUSE"] = "WAREHOUSE";
    SwivelNature["WATCH_CLOCK"] = "WATCH_CLOCK";
    SwivelNature["WOOD_PAPER_PRINTING"] = "WOOD_PAPER_PRINTING";
})(SwivelNature || (exports.SwivelNature = SwivelNature = {}));
var SwivelStatus;
(function (SwivelStatus) {
    SwivelStatus["AWAITING_APPROVAL"] = "AWAITING_APPROVAL";
    SwivelStatus["APPROVED"] = "APPROVED";
    SwivelStatus["REJECTED"] = "REJECTED";
})(SwivelStatus || (exports.SwivelStatus = SwivelStatus = {}));
var TransportMode;
(function (TransportMode) {
    TransportMode["SEA"] = "SEA";
    TransportMode["RAIL"] = "RAIL";
    TransportMode["AIR"] = "AIR";
    TransportMode["TRUCK"] = "TRUCK";
    TransportMode["BARGE"] = "BARGE";
})(TransportMode || (exports.TransportMode = TransportMode = {}));
var TransportType;
(function (TransportType) {
    TransportType["FCL"] = "FCL";
    TransportType["LCL"] = "LCL";
})(TransportType || (exports.TransportType = TransportType = {}));
var ValidationErrorSeverity;
(function (ValidationErrorSeverity) {
    ValidationErrorSeverity["ERROR"] = "error";
    ValidationErrorSeverity["WARNING"] = "warning";
})(ValidationErrorSeverity || (exports.ValidationErrorSeverity = ValidationErrorSeverity = {}));
var ValidationStatus;
(function (ValidationStatus) {
    ValidationStatus["PENDING"] = "pending";
    ValidationStatus["VALID"] = "valid";
    ValidationStatus["INVALID"] = "invalid";
})(ValidationStatus || (exports.ValidationStatus = ValidationStatus = {}));
var VatValidationStatus;
(function (VatValidationStatus) {
    VatValidationStatus["PENDING"] = "pending";
    VatValidationStatus["VALID"] = "valid";
    VatValidationStatus["INVALID"] = "invalid";
    VatValidationStatus["DOWNSTREAM_SERVER_DEAD"] = "downstream_server_dead";
})(VatValidationStatus || (exports.VatValidationStatus = VatValidationStatus = {}));
//# sourceMappingURL=types.gen.js.map